import { render, staticRenderFns } from "./subChannel.vue?vue&type=template&id=58d07812&scoped=true&"
import script from "./subChannel.vue?vue&type=script&lang=js&"
export * from "./subChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d07812",
  null
  
)

export default component.exports